;(function (angular, _, moment) {
  'use strict'
  const PDF_WITH_INVOICE_FLAG = 'pdf-with-interventions'

  class ProgressbarController {
    constructor (
      // Angular
      $state,
      // Libs
      // Managers
      // Services
      PreferencesService, SessionService, StatusService, AppAccessService, PennylaneService
      // Const
      // Resolved
    ) {
      this.state = $state
      this.sessionService = SessionService
      this.statusService = StatusService
      this.preferencesService = PreferencesService
      this.appAccessService = AppAccessService
      this.pennylaneService = PennylaneService
      this.haveChorusAccess = false
      this.pennylaneConnected = false
      this.featureFlags = []
    }

    $onInit () {
      if (this.obj.getType() === 'invoice' || this.obj.getType() === 'creditNote') {
        this.appAccessService.getCompanyRights().then((rights) => {
          rights.forEach((right) => {
            if (right.appName === 'CHORUS' && right.hasAccess) this.haveChorusAccess = true
          })
        })
        // Connexion Pennylane de la company — mémoïsée côté service (1 seul
        // appel réseau par session, partagé fiche + liste). Conditionne
        // l'affichage du bouton « Envoyer sur Pennylane ».
        this.pennylaneService.getConnectedCompany().then((company) => {
          this.pennylaneConnected = !!company
        })
      }
      this.saveButtonTooltip = this.formatSaveButtonTooltip(this.obj.isModel)
      this.cssClass = this.statusService.getCssClass(this.type, this.obj.status)
      this.preferencesService.getGeneralPrefs().then((generalPrefs) => {
        this.sendInvoiceByEmail = !generalPrefs.settings.sendInvoiceByEmail
      })
      this.preferencesService.getCompanyPrefs().then((companyPrefs) => {
        if (companyPrefs?.enabledFeatures?.pdfWithInterventions) {
          this.featureFlags.push(PDF_WITH_INVOICE_FLAG)
        }
      })
    }

    formatSaveButtonTooltip (isModel) {
      return isModel ? 'Sauvegarder le modèle' : 'sauvegarder'
    }

    displayPdfWithIntervention () {
      return this.featureFlags.includes(PDF_WITH_INVOICE_FLAG) && // Check flag
        !!_.get(this.obj, 'linkedData.solica.interventions', []).length && // Check if obj has interventions
        this.asPdfWithInterventions && // Check if function is bind
        ['quote', 'invoice'].includes(this.type) // only for invoice and quote for now
    }

    canChange () {
      return !this.readonly
    }

    getStatusLabel (type, status) {
      return this.statusService.getLabel(type, status)
    }

    getStatusAction (type, status) {
      return this.statusService.getAction(type, status)
    }

    getStatusTooltip (type, status) {
      return this.statusService.getTooltip(type, status)
    }

    getStatusCssClass (type, status) {
      return this.statusService.getCssClass(type, status)
    }

    getButtonCssClass (type, status) {
      return 'btn-' + this.statusService.getCssClass(type, status)
    }

    getStatusTransition (type, status) {
      return this.statusService.getAllowedStatus(type, status)
    }

    getFormattedDate (date, format) {
      return moment(date).format(format)
    }

    getLastStatusDate (type) {
      if (type && type === 'dunning') {
        return this.obj.updatedAt
      }
      if (!this.obj.history || !this.obj.history.length) return moment()
      return this.obj.history[this.obj.history.length - 1].date
    }

    isNew () {
      return (this.state.is('invoice.new') || this.state.is('quote.new') || this.state.is('creditnote.new'))
    }

    save (obj) {
      this.onSave({ obj: obj })
    }

    getTooltip () {
      var tip = this.getStatusTooltip(this.type, this.availableStatus[0]) || this.getStatusAction(this.type, this.availableStatus[0])
      var object
      switch (this.type) {
        case 'invoice':
          object = ' la facture'
          break
        case 'quote':
          object = ' le devis'
          break
        case 'creditnote':
          object = ' l\'avoir'
          break
        case 'order':
          object = ' l\'affaire'
          break
      }

      if (tip === 'Facturation') {
        return 'Passer en facturation'
      }
      return tip + object
    }

    isStatusSelectDisplayed () {
      if (!this.theForm) {
        return false
      }
      return this.obj.status !== 'paid' &&
        this.obj.status !== 'invoiced' &&
        this.obj.status !== 'refused' &&
        !this.isNew() &&
        this.canChange() &&
        this.availableStatus.length !== 1 &&
        this.theForm.$valid &&
        this.obj.isDetailsValid()
    }

    isNextStatusDisplayed () {
      if (!this.theForm) {
        return false
      }
      return this.availableStatus.length === 1 &&
        this.canChange() &&
        !this.isNew() &&
        this.obj._id &&
        this.theForm.$valid &&
        this.obj.fullTotal >= 0 &&
        this.obj.isDetailsValid()
    }

    isDisplayed (button) {
      switch (button) {
        case 'duplicate':
          return this.duplicate && this.obj?._id && !this.obj.isModel && this.obj.type !== 'deposit'
        case 'proforma':
          return this.obj.status === 'draft' && this.type === 'invoice' && this.obj._id && !this.obj.isModel
        case 'exports':
          return this.obj.status !== 'draft' && !this.obj.isModel
        case 'pdf':
          return true
        case 'factur-x':
          return (!this.obj.isArchived && !this.obj.isDeleted && (this.obj.getType() === 'invoice' || (this.obj.getType() === 'creditNote' && this.obj.invoiceRef)))
        case 'chorusExport':
          return (!this.obj.isArchived && !this.obj.isDeleted && ((this.obj.getType() === 'invoice' || (this.obj.getType() === 'creditNote' && this.obj.invoiceRef)) && this.haveChorusAccess && !['partly_paid', 'paid', 'draft'].includes(this.obj.status) && !this.obj?.chorusFields?.integratedOnChorus && !this.obj?.chorusFields?.integrationOngoing))
        case 'pennylaneEmit':
          // Factures uniquement (pas d'avoirs — décision projet), pas de gating
          // par droit d'app : Pennylane est disponible pour tous (≠ Chorus).
          // Émissible = la facture porte un numéro (même garde que le backend :
          // 422 « sans numéro ») ; plus de condition de statut ni de
          // cancelByUser (décision 2026-07-10, alignée backend).
          // Une facture DÉJÀ envoyée (`sentToPennylane`) reste éligible depuis
          // la fiche (décision 2026-09-09 : renvoi forcé possible « coûte que
          // coûte », confirmation dédiée dans toPennylane) — l'info « Facture
          // envoyée sur Pennylane » reste affichée à côté. L'action groupée
          // (selection-sidebar), elle, continue d'exclure les déjà envoyées.
          return (!this.obj.isArchived && !this.obj.isDeleted && this.obj.getType() === 'invoice' && this.pennylaneConnected && !!this.obj.number)
        case 'pdfWithInterventions':
          return this.displayPdfWithIntervention()
        case 'csv':
          return true
        case 'spreadsheet':
          return true
        case 'save':
          return this.isSaveButtonDisplayed()
        case 'send':
          return this.isSendButtonDisplayed()
        case 'nextStatus':
          return this.isNextStatusDisplayed() && !this.obj.isArchived && !this.readonly && this.obj._id && !this.obj.isModel
        case 'selectStatus':
          return this.isStatusSelectDisplayed() && !this.obj.isArchived && !this.readonly && this.obj._id && !this.obj.isModel
        case 'cancel':
          return this.isCancelButtonDisplayed() && !this.obj.isModel
      }
    }

    isSaveButtonDisplayed () {
      if (this.readonly) {
        return false
      }
      if (!this.theForm) {
        return false
      }
      if (this.obj.isArchived || this.obj.isDeleted) return false
      if (this.obj.status === 'paid' && !this.theForm.$dirty) {
        return false
      }
      if (this.obj.status === 'paid' && this.theForm.$dirty) {
        return true
      }
      if (this.obj.status === 'draft') {
        return this.theForm.$dirty
      }
      return this.theForm.$dirty && this.theForm.$valid
    }

    isSendButtonDisplayed () {
      return this.obj.status !== 'draft' && this.obj.status !== 'validated' && !this.obj.isModel && this.sendInvoiceByEmail
    }

    isCancelButtonDisplayed () {
      return this.type === 'invoice' && (this.obj.status === 'sent' || this.obj.status === 'validated') && !this.payments?.length && !this.obj.isModel && !this.obj.invoiceDeposit.length
    }

    isContainerDisplayed () {
      if (!this.theForm) {
        return false
      }
      if (this.obj.type === 'order' && this.obj.isArchived) return false
      if (this.obj.isModel && this.theForm.$dirty === false) return false
      return true
    }
  }

  ProgressbarController.$inject = [
    // Angular
    '$state',
    // Libs
    // Managers
    // Services
    'PreferencesService', 'SessionService', 'StatusService', 'AppAccessService', 'PennylaneService'
    // Const
    // Resolved
  ]

  angular.module('kilo.common.components')
    .component('progressbar', {
      bindings: {
        type: '=',
        obj: '<',
        availableStatus: '<',
        editable: '<',
        editMode: '<',
        theForm: '<',
        statusChange: '&?',
        onSave: '&?',
        cancel: '&?'
      },
      templateUrl: '/app/common/components/progressbar/progressbar.template.html',
      controller: ProgressbarController
    })
    .controller('ProgressbarController', ProgressbarController)
})(window.angular, window._, window.moment)
